export const imageUploadActionTypes = {
  START_IMAGE_UPLOAD: 'START_IMAGE_UPLOAD',
  IMAGE_UPLOAD_SUCCESS: 'IMAGE_UPLOAD_SUCCESS',
  IMAGE_UPLOAD_FAILURE: 'IMAGE_UPLOAD_FAILURE',
};
export const startImageUpload = () => ({
  type: imageUploadActionTypes.START_IMAGE_UPLOAD,
});

export const imageUploadSuccess = () => ({
  type: imageUploadActionTypes.IMAGE_UPLOAD_SUCCESS,
});
export const imageUploadFailure = () => ({
  type: imageUploadActionTypes.IMAGE_UPLOAD_FAILURE,
});
